module.exports = __webpack_public_path__ + "static/media/finish.d873e1c2.svg";